import api from "./api";
import API_ROUTES from "./apiRoutes";

export const getSystemLogs = async ({ lines = 200, date } = {}) => {
  const params = { lines };
  if (date) params.date = date;
  const res = await api.get(API_ROUTES.systemLogs.system, { params });
  return res.data;
};

export const getAuditLogs = async ({
  user_id,
  role,
  action,
  status,
  from,
  to,
  limit = 200,
  offset = 0,
} = {}) => {
  const params = {
    user_id,
    role,
    action,
    status,
    from,
    to,
    limit,
    offset,
  };

  Object.keys(params).forEach((key) => {
    if (params[key] === undefined || params[key] === null || params[key] === "") {
      delete params[key];
    }
  });

  const res = await api.get(API_ROUTES.systemLogs.audit, { params });
  return res.data;
};

export const getMyAuditLogs = async ({ limit = 50, offset = 0 } = {}) => {
  const params = { limit, offset };
  const res = await api.get(API_ROUTES.systemLogs.myAudit, { params });
  return res.data;
};
